






import { Component, Prop, Vue, Watch, Model, Emit } from "vue-property-decorator";

@Component({})
export default class FormInput extends Vue {
  /* -------------- prop ------------- */
  @Prop(String) placeholder?: string;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) onlyNum!: boolean; // 限制格式只能为数字

  /* -------------- Model ------------- */
  @Model("input", {
    type: String
  })
  inputValue?: string;

  /* -------------- data ------------- */
  value = "";

  /* -------------- emit ------------- */
  @Emit("input")
  changeValue (val: string) {
    return val;
  }

  /* -------------- watch ------------- */
  @Watch("value")
  onChangeValue (val: string) {
    this.changeValue(val);
  }

  @Watch("inputValue", { immediate: true })
  onInputValueChanged (val: string) {
    if (this.onlyNum) {
      this.value = val.replace(/[^\d]/g, "");
    } else {
      this.value = val;
    }
  }
  /* -------------- methods ------------- */
}
